import React from "react";
import { Box, Typography } from "@mui/material";
import { Colors } from "../../../../theme/colors";
import Selectbox from "../../../../components/Utils/Selectbox/Selectbox";

interface WorkAndPayTypeSelectProps {
  workType: string | null;
  payType: string | null;
  anchorElOpenWorkType?: HTMLElement | null;
  anchorElOpenPayDetails?: HTMLElement | null;
  handleClickMainCategory?: (
    e: React.MouseEvent<HTMLDivElement>,
    type: "WorkType" | "PayId"
  ) => void;
  handleCloseMainCategory?: (type: "WorkType" | "PayId") => void;
  setSelectionBoxValue?: (val: string, type: "WorkType" | "PayId") => void;
  isDiabled?: boolean
}

const WorkAndPayTypeSelect: React.FC<WorkAndPayTypeSelectProps> = ({
  workType,
  payType,
  anchorElOpenWorkType,
  anchorElOpenPayDetails,
  handleClickMainCategory,
  handleCloseMainCategory,
  setSelectionBoxValue,
  isDiabled = false
}) => {
  return (
    <Box
      sx={{
        marginTop: "20px",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <Box sx={{ width: "49%" }}>
        <Typography
          color={Colors.black}
          fontSize={"14px"}
          variant="h6"
        >
          Work Type
        </Typography>
        <Selectbox
          handleClick={(e) => handleClickMainCategory(e, "WorkType")}
          handleClose={() => handleCloseMainCategory("WorkType")}
          changeBoxValue={(val) => setSelectionBoxValue(val, "WorkType")}
          open={Boolean(anchorElOpenWorkType)}
          anchorEl={anchorElOpenWorkType}
          isCreatePage={true}
          title={workType || "WorkType"}
          defaultValue={workType}
          menuOption={["Full-time", "Part-time", "Contract", "Casual"]}
          isDiabled={isDiabled}
        />
      </Box>

      <Box sx={{ width: "49%" }}>
        <Typography
          color={Colors.black}
          fontSize={"14px"}
          variant="h6"
        >
          Pay Type
        </Typography>
        <Selectbox
          handleClick={(e) => handleClickMainCategory(e, "PayId")}
          handleClose={() => handleCloseMainCategory("PayId")}
          changeBoxValue={(val) => setSelectionBoxValue(val, "PayId")}
          open={Boolean(anchorElOpenPayDetails)}
          anchorEl={anchorElOpenPayDetails}
          isCreatePage={true}
          title={payType || "PayType"}
          defaultValue={payType}
          menuOption={["Hourly rate", "Annual salary", "Annual pluscommission"]}
          isDiabled={isDiabled}
        />
      </Box>
    </Box>
  );
};

export default WorkAndPayTypeSelect;
